import { DataSourceUploadExtendedTypes, DataSourceUploadTypes } from 'interfaces/components.interfaces'
import { RtmCreateDataSourceOptions } from 'modules/rtmDataSources/api/interfaces'

export enum TetrisScenarioTabsCodes {
  Input = 'Input',
  Output = 'Output',
}

export enum TetrisUploadStatuses {
  Failed = 'failed',
  Success = 'success',
  Loading = 'loading',
  Idle = 'idle',
}

export type TetrisCreateDataSource = ({ data, params }: RtmCreateDataSourceOptions) => void

export interface TetrisDataSource {
  type: DataSourceUploadTypes | DataSourceUploadExtendedTypes | null
  isUploaded: boolean
  title: string
  isLoading: boolean
  date?: string | null
  error?: boolean
}

export enum TetrisDSTypes {
  Products = 'products',
  Innovations = 'innovations',
  Uoms = 'uoms',
  SourcingCalendars = 'sourcingCalendars',
  MilkCalendars = 'milkCalendars',
  Plants = 'plants',
  Warehouses = 'warehouses',
  Materials = 'materials',
  MaterialContents = 'materialContents',
  MaterialGroups = 'materialGroups',
  Vendors = 'vendors',
  Buyers = 'buyers',
  SourcingParameters = 'sourcingParameters',
  MilkParameters = 'milkParameters',
  MilkTableParameters = 'milkTableParameters',
  NewFarms = 'newFarms',
  RegularSupplies = 'regularSupplies',
  SpotSupplies = 'spotSupplies',
  Shortage = 'shortage',
  StockSupplies = 'stockSupplies',
  SupplyScheme = 'supplyScheme',
  FarmSalesScheme = 'farmSalesScheme',
  PlantSalesScheme = 'plantSalesScheme',
  MovementScheme = 'movementScheme',
  SpotBuyers = 'spotBuyers',
  CoPackersContracts = 'coPackersContracts',
  RecoCapabilities = 'recoCapabilities',
  Derivation = 'derivation',
  MbAdjustments = 'mbAdjustments',
  Separation = 'separation',
  InboundCapacity = 'inboundCapacity',
  OutboundCapacity = 'outboundCapacity',
  StockBounds = 'stockBounds',
  BaseFormulas = 'baseFormulas',
  RecoFormulas = 'recoFormulas',
  MinBatches = 'minBatches',
  LineCapacities = 'lineCapacities',
  LinePriorities = 'linePriorities',
  MrAdjustments = 'mrAdjustments',
  LineBindings = 'lineBindings',
  Demand = 'demand',
  SourcingScheme = 'sourcingScheme',
  Deliveries = 'deliveries',
  Itineraries = 'itineraries',
  Shipments = 'shipments',
  PremadeVolumes = 'premadeVolumes',
  Rejections = 'rejections',
  DemandOptions = 'demandOptions',
}
